<div class="row" data-testid="strike-members-page">
    <div class="col-md-12">
        <div class="panel panel-danger ">
            <div class="panel-heading clearfix">
                <div class="col-sx-12 col-sm-6 col-md-3">
                    <h4 class="panel-title pull-left" data-testid="strike-members-header">UniteHERE Members</h4>
                </div>
                <div class="col-sx-12 col-sm-6 col-md-3">
                    <span class="pull-right" data-testid="totalCount">{{totalCount}} Members found</span>
                </div>
                <div class="col-sx-12 col-sm-12 col-md-6 col-lg-4">
                    <div class="input-group">
                        <input id="inputSearchMembers" (keyup.enter)="search(0)" type="search" [(ngModel)]="filterMembers" class="form-control shortInputSearch" placeholder="Filter.." data-testid="member-searchbox">
                        <div class="input-group-btn">
                            <button class="btn btn-primary" (click)="search(0);" data-testid="member-search-btn"><i class="glyphicon glyphicon-search"></i></button>
                            <button class="btn btn-primary" (click)="clearSearch();" data-testid="member-clear-search-btn"><i class="glyphicon glyphicon-remove-sign"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive" *ngIf="!loadingMembers">
                <table class="table table-striped table-condensed" data-testid="strike-members-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Ssn </th>
                            <th>Birth Date</th>
                            <th>Picket Line</th>
                            <th>Shift</th>
                            <th>DebitCard</th>
                            <th>Phone </th>
                            <th>Address </th>
                            <th>City, State Zip</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let member of strikeMembers" data-testid="member-row">
                            <td>
                                <div *ngIf="member.ImageExists">
                                    <img class="thumbnail" width="75px" height="50px" [src]="'Content/images/members/'+member.MemberId+'.jpg'" alt="{{member.MemberId}}">
                                </div>
                                <a
                                  (click)="openEditMemberModal(member.ID);"
                                  (keyup.enter)="openEditMemberModal(member.ID);"
                                  title="Edit {{member.MemberId}} details"
                                  [attr.data-testid]="'member-table-open-edit-member-' + member.ID"
                                  tabindex="0"
                                  ><strong>{{member.MemberId}}</strong></a>
                            </td>
                            <td [attr.data-testid]="'member-table-name-' + member.ID">{{member.LastName + ', '  + member.FirstName+ ' '+ member.MiddleName}}</td>
                            <td [ngClass]="getStatusColor(member.MemberStatus)" [attr.data-testid]="'member-table-status-' + member.ID">{{member.MemberStatus}}</td>
                            <td [attr.data-testid]="'member-table-last-four-ssn-' + member.ID">{{member.LastFourSsn}}</td>
                            <td [attr.data-testid]="'member-table-birth-date-' + member.ID">{{member.BirthDate | date:'MM/dd/yyyy'}}</td>
                            <td [attr.data-testid]="'member-table-strike-line-' + member.ID">{{member.StrikeLine}}</td>
                            <td [attr.data-testid]="'member-table-strike-shift-' + member.ID">{{member.StrikeShift}}</td>
                            <td [attr.data-testid]="'member-table-debit-card-' + member.ID">{{member.DebitCard}}</td>
                            <td [attr.data-testid]="'member-table-phone-' + member.ID">{{member.Phone}}</td>
                            <td [attr.data-testid]="'member-table-address-1-' + member.ID">{{member.Address_1}}</td>
                            <td [attr.data-testid]="'member-table-city-state-zip-' + member.ID">{{member.City + ', ' + member.State + ' ' + member.Zip}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-center">
                    <app-custom-pager [page]="page" [pagesCount]="pageCount" (pageChange)="search($event)"></app-custom-pager>
                </div>
            </div>
            <div *ngIf="loadingMembers">
                <div class="col-xs-4"></div>
                <div class="col-xs-4">
                    <i class="fa fa-refresh fa-4x fa-spin"></i> <span class="label label-primary">Loading members...</span>
                </div>
                <div class="col-xs-4"></div>
            </div>
        </div>
    </div>
</div>
